import { render, staticRenderFns } from "./classSideMenu.vue?vue&type=template&id=1dc1d886&scoped=true"
import script from "./classSideMenu.vue?vue&type=script&lang=js"
export * from "./classSideMenu.vue?vue&type=script&lang=js"
import style0 from "./classSideMenu.vue?vue&type=style&index=0&id=1dc1d886&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc1d886",
  null
  
)

export default component.exports